import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import { useCancelApplicationInterview } from './useCancelApplicationInterview'

interface CancelInterviewModalProps {
  interviewId: string
  onClose: () => void
}

export const CancelInterviewModal = ({ onClose, interviewId }: CancelInterviewModalProps) => {
  const { cancelApplicationInterview } = useCancelApplicationInterview()
  const handleCancelConfirm = async () => {
    await asyncAction(() => cancelApplicationInterview({ id: interviewId }))
    onClose()
  }
  return (
    <Modal
      title={i18n.t('ats.schedule_interview.confirm_cancel.title')}
      description={i18n.t('ats.schedule_interview.confirm_cancel.description')}
      illustration="holidays-event-cancel"
      onClose={onClose}
      onSubmit={handleCancelConfirm}
      footer={
        <Button type="negative" submit>
          {i18n.t('ats.schedule_interview.cancel_interview')}
        </Button>
      }
    />
  )
}
